import { render, staticRenderFns } from "./ExtAstaSxPreview.vue?vue&type=template&id=24a1bdf1"
import script from "./ExtAstaSxPreview.vue?vue&type=script&lang=js"
export * from "./ExtAstaSxPreview.vue?vue&type=script&lang=js"
import style0 from "./ExtAstaSxPreview.vue?vue&type=style&index=0&id=24a1bdf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports